/**
 * Esta semana (PRODUCT §4.7): the queue with statuses — the week's cards, what is in
 * lectura (aplicado el · se lee a partir del), what closed recently, and Próximas, the
 * backlog peek. Same data as the Inicio section, in full.
 */
import { useSetMerchantChrome } from '@/components/layout/MerchantChrome'
import { Card, Text, Tag } from '@nimbus-ds/components'
import { authService } from '@/api/auth'
import { EstaSemanaSection, QueueCardView, fmtDia, useQueue } from '@/components/merchant/EstaSemana'

const CALIBRATION_DAYS = 14

function readFrom(iso: string | null): string {
  if (!iso) return ''
  return fmtDia(new Date(new Date(iso).getTime() + CALIBRATION_DAYS * 86400000).toISOString())
}

export function MerchantSemana() {
  const storeId = authService.getCurrentStoreId()
  const [queue, setQueue] = useQueue(storeId)

  useSetMerchantChrome({
    title: 'Esta semana',
    subtitle: 'Lo que hay para hacer, lo que está en lectura y lo que sigue.',
    backTo: '/merchant',
    showStoreOnDesktop: true,
  })

  if (!queue) return <Text className="py-6 text-center">Cargando…</Text>

  return (
    <div className="flex flex-col gap-5 md:gap-6">
      <EstaSemanaSection queue={{ ...queue, backlog: [] }} onQueue={setQueue} />

      {queue.active.length > 0 && (
        <section className="flex flex-col gap-2">
          <Text fontWeight="medium">En lectura</Text>
          {queue.active.map((c) => (
            c.kind === 'hygiene' && c.hygiene
              ? <QueueCardView key={c.actionable_id} card={c} onChange={() => {}} />
              : (
                <Card key={c.actionable_id}>
                  <div className="flex flex-col gap-1">
                    <div className="flex flex-wrap items-center gap-2">
                      <Tag appearance="primary">Activo desde el {fmtDia(c.activated_at)}</Tag>
                      <Text fontWeight="medium">{c.name}</Text>
                    </div>
                    <Text fontSize="caption" color="neutral-textLow">Se lee a partir del {readFrom(c.activated_at)}.</Text>
                  </div>
                </Card>
              )
          ))}
        </section>
      )}

      {queue.done.length > 0 && (
        <section className="flex flex-col gap-2">
          <Text fontWeight="medium">Hecho</Text>
          {queue.done.map((c) => (
            <Card key={c.actionable_id}>
              <div className="flex flex-col gap-1">
                <div className="flex flex-wrap items-center gap-2">
                  <Tag appearance="success">Hecho</Tag>
                  <Text fontWeight="medium">{c.name}</Text>
                </div>
                <Text fontSize="caption" color="neutral-textLow">
                  {c.verify === 'catalog' && c.verified_at ? `Confirmado en tu catálogo el ${fmtDia(c.verified_at)}.` : 'Marcado como hecho.'}
                </Text>
              </div>
            </Card>
          ))}
        </section>
      )}

      {(queue.backlog.length > 0 || queue.snoozed.length > 0) && (
        <section className="flex flex-col gap-2">
          <Text fontWeight="medium">Próximas</Text>
          <Card padding="none">
            <div className="px-4 md:px-5">
              {[...queue.backlog, ...queue.snoozed].map((c, i, all) => (
                <div key={c.actionable_id} className={`py-3 ${i === all.length - 1 ? '' : 'border-b border-[#f0f0f0]'}`}>
                  <Text>{c.name}</Text>
                  {c.skipped_at && <Text fontSize="caption" color="neutral-textLow">Guardada el {fmtDia(c.skipped_at)}.</Text>}
                </div>
              ))}
            </div>
          </Card>
          <Text fontSize="caption" color="neutral-textLow">
            Llegan de a {queue.cards_per_week} por semana según tu preferencia. Se cambia en Preferencias.
          </Text>
        </section>
      )}
    </div>
  )
}
